import { render, staticRenderFns } from "./Uitkomsten.vue?vue&type=template&id=365a8f8d"
import script from "./Uitkomsten.vue?vue&type=script&lang=js"
export * from "./Uitkomsten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports